"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertUnreachable = void 0;
var assertUnreachable = function (_, message) {
    if (message === void 0) { message = "Didn't expect to get here"; }
    throw new Error(message);
};
exports.assertUnreachable = assertUnreachable;
